import React from 'react';
import { Container } from 'react-bootstrap';

import SectionWrapper from 'components/layout/SectionWrapper';
import BedBoard from 'components/BedBoard/BedBoard';

const BedBoardPage: React.FC = () => (
  <Container className="my-5 site-content">
    <SectionWrapper>
      <BedBoard />
    </SectionWrapper>
  </Container>
);

export default BedBoardPage;
